import { CloudRole } from "@modules/graphql/types"

import { useOrganizationPermissionsFieldsFragment } from "@modules/organization/fragments.generated"

export default function useIsOrganizationOwner(organizationId: string) {
  const { data } = useOrganizationPermissionsFieldsFragment(organizationId)

  return data?.permissions?.role === CloudRole.Owner
}
